import { z } from "@/zod";

export const SETTLEMENT_TYPE_HOURLY_RATE = "hourly_rate";
export const SETTLEMENT_TYPE_MONTHLY_RATE = "monthly_rate";
export const SETTLEMENT_TYPE_VISIT_FEE = "visit_fee";

export const SETTLEMENT_TYPE = [
  SETTLEMENT_TYPE_HOURLY_RATE,
  SETTLEMENT_TYPE_MONTHLY_RATE,
  SETTLEMENT_TYPE_VISIT_FEE,
] as const;

export const SETTLEMENT_TYPE_HOURLY_RATES = [
  SETTLEMENT_TYPE_HOURLY_RATE,
  SETTLEMENT_TYPE_MONTHLY_RATE,
] as const;

export const settlementType = z.enum(SETTLEMENT_TYPE);

export const settlementTypeHourlyRates = z.enum(SETTLEMENT_TYPE_HOURLY_RATES);
